import * as React from 'react';
import { STATE } from 'app/constants';
import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { AuthState } from 'app/types-shared';
import { FooterProps } from 'app/shell/types';
import { SupportLink } from 'app/shell/components/footer/support-link';
import styles from './footer.scss';

export class Footer extends React.Component<FooterProps, any> {

  public static statePath: string = STATE.app;

  private renderLink(link: string, title: string, shouldRenderLink: boolean) {
    return shouldRenderLink ?
      <Link to={link} className="standalone-link">{title}<MdKeyboardArrowRight className="standalone-link-arrow" />
      </Link> :
      title;
  }

  public render() {
    const { language, location, userGroup, unit } = this.props.userInfo || {} as any;
    const {
      showFooter, shouldRenderLinks, translation, supportEmailAddress, onAboutModal,
      sharedState
    } = this.props;
    const isAuthenticated = sharedState && sharedState.authState === AuthState.Authenticated;

    return showFooter && isAuthenticated
      ? (<div className={'container main-grid'}>
        <div className={`row ${styles.footer}`}>
          <div className="col-md-6">
            {!!supportEmailAddress && <div className={styles.panel}>
              <h4 className={styles.head}>{translation.contact_information}</h4>
              <div>
                {translation.any_problems}
              </div>

              <div>
                <SupportLink url={supportEmailAddress} />
              </div>
            </div>}

            <div className={styles.panel}>
              <Link to="#" className="standalone-link" onClick={onAboutModal}>
                {translation.about_synergi}
                <MdKeyboardArrowRight className="standalone-link-arrow" />
              </Link>
            </div>

          </div>
          <div className="col-md-3">
            <div className={styles.panel}>
              <h4 className={styles.head}> <span className={`globe ${styles.icon}`} />
                {translation.language}
              </h4>
              <div>
                {this.renderLink(routeConstants.userProfileViewWithFocusFor('language'),
                  language && language.description, shouldRenderLinks)}
              </div>
            </div>

            <div className={styles.panel}>
              <h4 className={styles.head}> <span className={`location ${styles.icon}`} />
                {translation.your_location}
              </h4>
              <div>
                {this.renderLink(routeConstants.userProfileViewWithFocusFor('location'),
                  location && location.description, shouldRenderLinks)}
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className={styles.panel}>
              <h4 className={styles.head} > <span className={`user-group ${styles.icon}`} />
                {translation.your_user_group}
              </h4>
              <div>
                {this.renderLink(routeConstants.userProfileViewWithFocusFor('usergroup'),
                  userGroup && userGroup.description, shouldRenderLinks)}
              </div>
            </div>

            <div className={styles.panel}>
              <h4 className={styles.head}> <span className={`unit ${styles.icon}`} />
                {translation.your_unit}
              </h4>
              <div>
                {this.renderLink(routeConstants.userProfileViewWithFocusFor('unit'), unit && unit.description, shouldRenderLinks)}
              </div>
            </div>

          </div>
        </div>
      </div>)
      : null;
  }
}
